/*
  The marginDiff variable keeps the value referring to the margins
  that the iframe has regarding the parent div, because when we
  change the rendering size we change the value of the parent div
  and not the iframe, so we need to compensate with 42 pixels the
  difference between them.
*/
export const MARGIN_DIFF: number = 42

export enum PREVIEW_BREAKPOINTS_SIZES {
  DESKTOP = window.innerWidth,
  TABLET = 768,
  MOBILE = 320,
}

export type PreviewBreakpoint = 'desktop' | 'tablet' | 'mobile' | 'custom'

export const isPreviewBreakpoint = (
  data: unknown,
): data is PreviewBreakpoint => {
  return (
    data === 'desktop' ||
    data === 'tablet' ||
    data === 'mobile' ||
    data === 'custom'
  )
}

export const PREVIEW_BREAKPOINTS_MINIMUM_SIZE: number = 320

export const PREVIEW_EDITOR_FORM_MINIMUM_SIZE: number = 400
